module.exports = __webpack_public_path__ + "img/tbmsidebar.d922c0bf.png";